import { request } from "../utils/request"


/**
 * 根据关键字查询企业列表数据
 * @param params 
 * @returns 
 */
export const searchCmpsByName = (params: { keyword: string }) => {
    return request.get('/company/search', { params })
}

/**
 * 获取分页协议模版
 * @param params 
 * @returns 
 */
export const getCmps = (params?: { page: number, limit: number }) => {
    return request.get('/company', { params })
}

/**
 * fetch one
 * @param params 
 * @returns 
 */
export const getCmpDetail = (params?: { cmp: number }) => {
    return request.get('/company/detail', { params })
}

/**
 * update 企业信息
 * @param data 
 * @returns 
 */
export const updateCmp = (data: {
    id: number,
    name: string;
    logo: string,
    title: string,
    board: string,
    video: string,
    images: string,
    pages: string
}) => {
    return request.post('/company/update', data)
}

/**
 * create 企业
 * @param data 
 * @returns 
 */
export const createCmp = (data: {
    name: string;
    logo: string,
    title: string,
    board: string,
    video: string,
    images: string,
    pages: string
}) => {
    return request.post('/company/create', data)
}


/**
 * fetch company resource
 * @param data 
 * @returns 
 */
export const createCmpResource = (data: {
    type: ResourceType;
    resource: object
}) => {
    return request.post('/company/create/resource', data)
}

/**
 * 企业资源
 * @param params 
 * @returns 
 */
export const getCmpResource = (params?: { page: number, type: ResourceType }) => {
    return request.get('/company/resource', { params })
}

/**
 * update 企业资源
 * @param params 
 * @returns 
 */
export const updateCmpResource = (data: {
    id: number,
    resource: object
}) => {
    return request.post('/company/update/resource', data)
}


/**
 *  delete company resource
 * @param data
 * @returns 
 */
export const deleteCmpResource = (data: {
    id: number,
}) => {
    return request.post('/company/delete/resource', data)
}


export enum ResourceType {
    Honor = "Honor", // 资质荣誉
    Achv = "Achv", // 业绩
    Partner = 'Partner', // 合作伙伴
}